import { queryOptions } from "@tanstack/react-query";

import { externalFinalPageSettingsApi } from "./api";

import GetExternalFinalPageSettingsRequest = App.Http.Requests.ExternalFinalPageSetting.GetExternalFinalPageSettingsRequest;
import GetExternalFinalPageSettingRequest = App.Http.Requests.ExternalFinalPageSetting.GetExternalFinalPageSettingRequest;

export const externalFinalPageSettingsQueryOptions = {
    index: (offerId: string, request: GetExternalFinalPageSettingsRequest) =>
        queryOptions({
            queryKey: ["getExternalFinalPageSettings", offerId, request],
            queryFn: () => externalFinalPageSettingsApi.index(offerId, request),
        }),
    show: (offerId: string, externalFinalPageSettingId: string, request: GetExternalFinalPageSettingRequest) =>
        queryOptions({
            queryKey: ["getExternalFinalPageSetting", offerId, externalFinalPageSettingId, request],
            queryFn: () => externalFinalPageSettingsApi.show(offerId, externalFinalPageSettingId, request),
        }),
};